import React from "react";
import { useDrag } from "react-dnd";
import { useTranslation } from "react-i18next";

import { ItemTypes } from "../../utils/items";
import "./Compare.css";

const Apartment = (props) => {
	const [{ isDragging }, drag] = useDrag({
		item: {
			type: ItemTypes.APARTMENT,
			id: props.id,
			name: props.name,
			quadrature: props.quadrature,
			thumbnail: props.thumbnail,
			apartmentType: props.type,
		},
		collect: (monitor) => ({
			isDragging: !!monitor.isDragging(),
		}),
	});

	const { t } = useTranslation();

	return (
		<div className="apartment" ref={drag}>
			<img
				className="apartment-garbage-img"
				src="design/new-exports/garbage.png"
				onClick={() => {
					props.removeFavourite(props.id);
				}}
				alt=""
			/>
			<div
				className="compare__apartment--info"
				style={{
					opacity: isDragging ? "0.5" : "1.0",
					pointerEvents: "none",
				}}
			>
				<p className="compare__apartment--info-name">
					{" "}
					{t("APARTMENT")}{" "}
				</p>
				<p className="compare__apartment--info-id"> {props.name} </p>
				<p className="compare__apartment--info-type"> {props.type} </p>
				<p className="compare__apartment--info-quadrature">
					{" "}
					{props.quadrature} m<sup>2</sup>{" "}
				</p>
			</div>
		</div>
	);
};

export default Apartment;
